<template>
  <div class="save-preset">
    <GwInput
      :value="l_preset.name"
      :label="$t('common.new_preset_name')"
      type="text"
      autofocus
      density="compact"
      variant="outlined"
      tstPrefix="drill_name_"
      :getErrors="
        () => (nameError ? [$t(`messages.${nameError}`, { max_chars: nameMaxChars })] : [])
      "
      @input="(_e, value) => (l_preset.name = value)"
      @keydown:enter="apply"
    />
    <GwInput
      :value="l_preset.description"
      class="mt-4"
      :label="$t('common.new_preset_description')"
      tstPrefix="drill_description_"
      :isTextArea="true"
      :getErrors="
        () =>
          descriptionError
            ? [$t(`messages.${descriptionError}`, { max_chars: descriptionMaxChars })]
            : []
      "
      @input="(_e, value) => (l_preset.description = value)"
      @keydown:enter="apply"
    />
  </div>
</template>

<script>
import { getTrainerClearQuery } from '@/helpers/trainer_presets'
import format_mix from '@/mixins/format_mix'
import GwInput from '@/components/lib/GwInput'

export default {
  name: 'TrainerPresetSave',
  components: {
    GwInput,
  },
  mixins: [format_mix],
  props: {
    namespace: { String, required: true },
    tmpNamespace: { String, required: true },
  },
  data() {
    return {
      l_preset: null,
      nameError: false,
      descriptionError: false,
      nameMaxChars: 200,
      descriptionMaxChars: 500,
    }
  },
  created() {
    this.l_preset = { ...this.$store.getters.drills_selected_drill }
  },
  // mounted() {
  //   // iphone moves content up when keyboard is shown
  //   setTimeout(() => {
  //     const c = this.$refs.input
  //     if (c?.$el) {
  //       c.$el.scrollIntoView() select()
  //     }
  //   }, 300)
  // },
  methods: {
    getNameError() {
      let res = false
      this.nameError = false
      const name = this.l_preset.name.trim()
      if (name.length > this.nameMaxChars) {
        this.nameError = 'trainer_preset_name_too_many_characters'
        res = true
      }
      return res
    },
    getDescriptionError() {
      let res = false
      this.descriptionError = false
      const description = this.l_preset.description?.trim() || ''
      if (description.length > this.descriptionMaxChars) {
        this.descriptionError = 'trainer_preset_description_too_many_characters'
        res = true
      }
      return res
    },
    apply() {
      if (this.getNameError()) return
      if (this.getDescriptionError()) return

      this.l_preset.name = this.l_preset.name.trim()
      this.l_preset.description = this.l_preset.description?.trim() || ''

      if (!this.l_preset.name.length) {
        this.nameError = 'trainer_preset_name_empty_error'
        return
      }

      const { drills_all } = this.$store.getters
      if (drills_all.some(p => p.id !== this.l_preset.id && p.name === this.l_preset.name)) {
        this.nameError = 'trainer_preset_name_exists_error'
        return
      }

      let id = this.l_preset.public ? '' : this.l_preset.id
      const tags = this.l_preset.public ? [] : this.l_preset.tags || []
      if (!drills_all.some(i => i.id === id)) {
        id = ''
      }
      const router_query = this.$store.getters[`${this.tmpNamespace}/router_query`]
      // console.log(router_query)
      // debugger
      const completePreset = {
        id,
        // category_id: 'custom_drills',
        name: this.l_preset.name,
        description: this.l_preset.description,
        favorite: !!this.l_preset.favorite,
        query: getTrainerClearQuery(router_query),
        tags,
      }
      this.$store.dispatch('drills_set_drill', {
        items: [completePreset],
        hasMessage: true,
        method: id ? 'PATCH' : 'POST',
        namespace: this.namespace,
      })

      if (this.$store.getters.hands_configure) {
        this.$store.dispatch(`${this.namespace}/router_update_query`, {
          query: completePreset.query,
          push: false,
        })
      }

      // if (id) {
      //   this.$store.commit('drills_set',
      //     { key: 'drills_selected_drill', value: completePreset })
      // }
    },
  },
  computed: {
    loading() {
      return this.$store.getters.api_get('api_poker_drill').loading
    },
  },
  watch: {
    'l_preset.name': function () {
      this.getNameError()
    },
    'l_preset.description': function () {
      this.getDescriptionError()
    },
  },
}
</script>

<style lang="scss">
.save-preset {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  // width: 32rem;
  min-height: 15.5rem;
  max-width: 100%;

  // kinda hacky but works
  min-width: clamp(1px, 32rem, calc(100vw - 2rem));
  max-width: 100%;
}
</style>
